import axiosInstance from "../api/axiosInstance";

// Surveys (2026-10-05): the expectations survey's answers, read only.
export const getExpectationsSurvey = (params) =>
  axiosInstance.get("/admin/surveys/expectations", { params });
